import React, { useMemo, useState } from "react"; // ✅ added
import styles from "./PortofolioTable.module.css";
import { formatCurrency } from "../../utils";
import { Portfolio } from "../dashboard/PortofolioSection";

export const PortfolioTable = ({ overview, loadingOverview }) => {
  const [hideSmallAssets, setHideSmallAssets] = useState(false);

  // build the mapped assets first
  const mappedAssets = useMemo(() => {
    return (overview?.details || []).map((detail) => ({
      token: detail?.coin_name,
      amount: detail?.balance,
      price: detail?.market_price,
      change: detail?.change24h,
      total_usdt: detail?.usdt_value,
      exchange: detail?.exchange_name,
    }));
  }, [overview?.details]);

  // filter by toggle
  const filteredAssets = useMemo(() => {
    if (!hideSmallAssets) return mappedAssets;
    return mappedAssets.filter((a) => (a.total_usdt || 0) >= 1);
  }, [mappedAssets, hideSmallAssets]);

  return (
    <div
      className="bg-white rounded-xl p-4"
      style={{ border: "1px solid #dde1e6" }}
    >
      <div className="flex items-end justify-between mb-3">
        <p className="text-3xl font-bold text-slate-900">
          ${formatCurrency(overview?.summary?.aggregate_balance_usdt || 0)}
        </p>
        <label className="flex items-center space-x-2 !cursor-pointer">
          <input
            type="checkbox"
            checked={hideSmallAssets}
            onChange={() => setHideSmallAssets((v) => !v)}
            className="form-checkbox h-4 w-4 text-blue-600 !cursor-pointer"
          />
          <span className="text-sm text-gray-700">Hide &lt; 1 USDT</span>
        </label>
      </div>

      <Portfolio loading={loadingOverview} assets={filteredAssets} />
    </div>
  );
};
